const ActionButtons = ({ onMerge, onDownload, showDownload }) => (
  <div>
    <p className="text-gray-700 font-medium mb-2">
      Select the invoices you want to merge.
    </p>
    <button
      onClick={onMerge}
      className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md ml-5"
    >
      Merge And Edit Invoices
    </button>
  </div>
);

export default ActionButtons;
